import script from "./PerCapitaSpending.vue?vue&type=script&setup=true&lang=js"
export * from "./PerCapitaSpending.vue?vue&type=script&setup=true&lang=js"

import "./PerCapitaSpending.vue?vue&type=style&index=0&id=d3786846&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3786846"]])

export default __exports__